function init() {
  'use strict'
  const $hotels_info_with_filtering = $('.hotels-info-with-filtering.meetings')
  if (!$hotels_info_with_filtering.length) return false

  $(document)
    .on('click', '.hotel-list-link', function (event) {
      event.preventDefault()

      $('#hotels-filter-map').hide()
      $('.filters-sidebar').removeClass('active')

      $('.hotel-map-link').removeClass('disabled')
      $(this).addClass('active')
      $('.current[data-block-list]').removeClass('hidden current')
    })

    .on('click', '.filters-sidebar [data-close-panel]', function (event) {
      event.preventDefault()

      $('.hotel-list-link').trigger('click')
    })

  $(document).on('change', '.hotel-list .card [type=checkbox]', function () {
    $(this).closest('.card').toggleClass('selected')
  })
}

init()
